"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlagPermissions = void 0;
const flagConfig_1 = require("../permissions/flagConfig");
const getFlagPermissions = (flags) => {
    let config = {};
    const featureFlagPermissionConfigEntries = Object.entries(flagConfig_1.flagConfig);
    for (const entry of featureFlagPermissionConfigEntries) {
        const [flagName, permissionConfig] = entry;
        if (flags.has(flagName)) {
            config = Object.assign(Object.assign({}, config), permissionConfig);
        }
    }
    return config;
};
exports.getFlagPermissions = getFlagPermissions;
